import * as React from 'react';
import {Definition, PredefinedField} from '../lib/types';
import {Typography} from '@mui/material';
import * as path from 'path';
import PortalUserContext from '~common/lib/portal-user-context';
import {isEmpty} from 'lodash'

export function setValueAtPath(
  path: string,
  value: any,
  setValue: any
): {err: any; data: any} {
  return setValueAtPathWithOpts(path, value, setValue, {});
}

export function setValueAtPathWithOpts(
  path: string,
  value: any,
  setValue: any,
  opts: any
): {err: any; data: any} {
  // Trim off leading /
  if (path.indexOf('/') == 0) {
    path = path.substring(1);
  }

  if (!opts) {
    opts = {};
  }

  const pathParts = path.split('/');

  const currentElement: any = pathParts[0];

  let rest: Array<string> = [];
  if (pathParts.length > 1) {
    rest = pathParts.splice(1);
  }

  // If we are injecting into a bare object, we need to created the children objects as we hit them
  if (!value) {
    // Try to figure out from the upcoming path what kind of value we are expecting
    if (isNaN(currentElement)) {
      // This is not a number, so it could still have a : in it
      if (currentElement.indexOf(':') > -1) {
        value = [];
      } else {
        value = {};
      }
    } else {
      // The path is a number, so it is an array
      value = [];
    }
  }

  // Now that we have our value we can proceed
  const kind: string = typeof value;

  switch (kind) {
    case 'object':
      // See if it is an array
      if (isArray(value)) {
        // If all we are asking for is the slice, return that
        if (currentElement.length == 0) {
          return {err: null, data: value};
        }
        const idxParts: Array<string> = currentElement.split(':');

        switch (idxParts.length) {
          case 1:
            try {
              // this is an index based path
              const iv: number = parseInt(idxParts[0]);
              if (value.length < iv) {
                console.warn(
                  "invalid slice index path component '" +
                    currentElement +
                    "': index out of bounds"
                );
                return {err: null, data: undefined};
              }

              const svpResp = setValueAtPath(
                rest.join('/'),
                value[iv],
                setValue
              );
              if (svpResp.err) {
                return {err: svpResp.err, data: null};
              }
              value[iv] = svpResp.data;
              return {err: null, data: value};
            } catch (e) {
              return {err: e, data: undefined};
            }

          case 2:
            // this is a key:value path
            for (var iv = 0; iv < value.length; iv++) {
              const kv = value[iv];
              const kvival = getValueForField(idxParts[0], kv);

              if (kvival == idxParts[1]) {
                const svpResp = setValueAtPath(
                  rest.join('/'),
                  value[iv],
                  setValue
                );
                if (svpResp.err) {
                  return {err: svpResp.err, data: null};
                }
                value[iv] = svpResp.data;
                return {err: null, data: value};
              }
            }

            return {
              err:
                "invalid slice index path component '" +
                currentElement +
                "': not found",
              data: undefined
            };

          default:
            return {
              err:
                "invalid slice index path component '" +
                currentElement +
                "': malformed",
              data: undefined
            };
        }
      } else {
        //
        // It is an object
        // If all we are asking for is the object, so set that
        if (currentElement.length == 0) {
          value = setValue;
          return {err: null, data: value};
        }
        //
        if (rest.length == 0) {
          if (opts && opts.emptyAsNull && !setValue) {
            value[currentElement] = null;
          } else {
            value[currentElement] = setValue;
          }
          return {err: null, data: value};
        } else {
          const restPath: string = rest.join('/');
          const pathValue = value[currentElement];

          // if(pathValue==undefined||pathValue==null) {
          //   // If there is currently no value then just set it and return
          //    value[currentElement] = setValue

          // }

          const svpResp = setValueAtPath(restPath, pathValue, setValue);
          if (svpResp.err) {
            return {err: svpResp.err, data: null};
          }
          value[currentElement] = svpResp.data;
          return {err: null, data: value};
        }

        break;
      }

    default:
      if (rest.length > 0) {
        return {
          err: 'cannot use path ' + rest.join('/') + ' for simple variable)',
          data: undefined
        };
      } else {
        // Set it and return it
        if (opts.emptyAsNull && !setValue) {
          value = null;
        } else {
          value = setValue;
        }
        return {err: null, data: value};
      }
  }

  return {err: null, data: undefined};
}

export function getValueAtPath(path: string, value: any): any {
  const pathParts = path.split('/');
  const currentElement = pathParts[0];
  let rest: Array<string> = [];
  if (pathParts.length > 1) {
    rest = pathParts.splice(1);
  }

  const kind: string = typeof value;

  switch (kind) {
    case 'object':
      // See if it is an array
      if (value && value.isArray && value.isArray()) {
        // If all we are asking for is the slice, return that
        if (currentElement.length == 0) {
          return value;
        }
        const idxParts: Array<string> = currentElement.split(':');

        switch (idxParts.length) {
          case 1:
            try {
              // this is an index based path
              const iv: number = parseInt(idxParts[0]);
              if (value.length < iv) {
                console.warn(
                  "invalid slice index path component '" +
                    currentElement +
                    "': index out of bounds"
                );
                return undefined;
              }

              return getValueAtPath(rest.join('/'), value[iv]);
            } catch (e) {
              return undefined;
            }

          case 2:
            // this is a key:value path
            for (var iv = 0; iv < value.length; iv++) {
              const kv = value[iv];
              const kvival = getValueForField(idxParts[0], kv);
              if (kvival == idxParts[1]) {
                return getValueAtPath(rest.join('/'), kv);
              }
            }

            console.warn(
              "invalid slice index path component '" +
                currentElement +
                "': not found"
            );
            return undefined;

          default:
            console.warn(
              "invalid slice index path component '" +
                currentElement +
                "': malformed"
            );
            return undefined;
        }
      } else {
        //
        // It is an object
        // If all we are asking for is the object, return that
        if (currentElement.length == 0) {
          if(rest.length == 0){
            return value;
          } else {
            return getValueAtPath(rest.join('/'), value);
          }
        }

        //
        if (rest.length == 0) {
          // 03/26/2021 MV: This would break if value is null which happens when you clear a relation field
          // return value[currentElement];
          return (value||{})[currentElement];
        } else {
          if (!value) {
            value = {}
          }
          return getValueAtPath(rest.join('/'), value[currentElement]);
        }

        break;
      }
    default:
      // This is a type where we are just going to return the value
      if (rest.length > 0) {
        console.warn(
          'cannot use path ' + rest.join('/') + ' for simple variable)'
        );
        return undefined;
      }
      break;
  }
}

function characterTrim(s, mask) {
  while (~mask.indexOf(s[0])) {
      s = s.slice(1);
  }
  while (~mask.indexOf(s[s.length - 1])) {
      s = s.slice(0, -1);
  }
  return s;
}



export function applyConditional(
  basisPath: string,
  conditionalAttribute: any,
  i: any,
  field: PredefinedField,
  onEvaluateConditional: Function,
  onAccessRootData: Function
) {
  let bp = basisPath;
  if (!bp) {
    bp = '|basisPath|';
  }

  if (
    conditionalAttribute &&
    conditionalAttribute.path &&
    conditionalAttribute.operator &&
    conditionalAttribute.value != null &&
    conditionalAttribute.value != undefined &&
    conditionalAttribute.attributeValue
  ) {

    const templateFuncMap = {
      "pluckRelationValueAtPath": function (data: any, relationPath: string, subValueKey: string, basePath: string,) {
      
        // var pathKeys = relationPath.toString().split("/");
    
        let vap: any
        if(relationPath.indexOf("~") != 0){
          // relationPath = path.join(basePath, relationPath);
          // // Replace the basis path placeholder
          // relationPath = relationPath.replace('|basisPath|', '');
          vap = getValueAtPath(relationPath, data)
        } else {
          vap = onAccessRootData(relationPath)
        }
    
        // relationPath = relationPath.replace(/^~/, "")
        // // now rectify the full path.
        // if (relationPath.startsWith('/')) {
        //   relationPath = relationPath.replace(/^\//g, '');
        // }
        

    
    
        if (vap && vap.value) {
    
          return vap.value[subValueKey] 
        }
        
      },

      "accessRootValue": function (path: string,) {
        if (onAccessRootData) {
          return onAccessRootData(path)
        }
      },

      "getValueAtPath": getValueAtPath,
    }
    
    const findValueForTemplate = function(attributeValue: any) {
      var replacementExpr = new RegExp(/{{(.*)}}/)
      
      var condExpr = attributeValue.match(replacementExpr);

      let foundValue = ""
      if (condExpr) {
        var parts = condExpr[1].toString().split(" ");   
        var funcName = parts.shift()
        var trimmedParts: any[] = []
        for (let part of parts) {
          if (part == ".") {
            trimmedParts.push(i)
          } else {
            let s = characterTrim(part, '\"')  
            trimmedParts.push(s)
          }
          
        }
        trimmedParts.push(bp)
    
        var fn = templateFuncMap[funcName]
        
        if (fn != null) {
          foundValue = fn.call(this, ...trimmedParts)
          return {value: foundValue, match: true}
        }
      } else {
        return {value: "", match: false}
      }
    } 
    // Initially a no op
    // Get the path relative the the basis path
    //
    //
    let fullPath =   conditionalAttribute.path
    // if(!fullPath.indexOf("~") == 0){
    //   fullPath = path.join(bp, conditionalAttribute.path);
    //   // Replace the basis path placeholder
    //   fullPath = fullPath.replace('|basisPath|', '');
    // }


    // now rectify the full path.
    if (fullPath.startsWith('/')) {
      fullPath = fullPath.replace(/^\//g, '');
    }

    // Get the value of the path
    let pv: any
    if(fullPath.indexOf("~") != 0){
      // relationPath = path.join(basePath, relationPath);
      // // Replace the basis path placeholder
      // relationPath = relationPath.replace('|basisPath|', '');
      pv = getValueAtPath(fullPath, i);
      
    } else {
      if (onAccessRootData) {
        pv = onAccessRootData(fullPath)
      } else {
        pv = getValueAtPath(fullPath, i);
      }
      
      
    }


    // There are some things that we want to be able to support in most contexts, such as what type of user are we talking about.
    if (conditionalAttribute.path == '_userType') {
      pv = PortalUserContext.userType;
    }

    let exprResult: boolean = false;
    let stopEvaluation: boolean = false;


    if (onEvaluateConditional) {
      const resp = onEvaluateConditional(
        fullPath,
        conditionalAttribute,
        pv,
        i,
        field
      );
      exprResult = resp['exprResult'];
      stopEvaluation = resp['stopEvaluation'];
    }

    // If we have not implemented a custom evaluator, or that evaluator has indicted that we should keep going
    // See form-based-editor for usage example
    if (!stopEvaluation) {
      // Set up the conditional to match the type of the pv
      // Determine whether the expression validates
      exprResult = baseConditionalEval(pv, conditionalAttribute, i)
    }


    // If it does, go ahead and set the value
    if (exprResult) {
      // Now we know that the condition was met, we can update the field attribute as appropriate
      //
      let foundValue = conditionalAttribute.attributeValue 
      let findValResponse = findValueForTemplate(conditionalAttribute.attributeValue)
      if (findValResponse && findValResponse.match == true) {
        foundValue = findValResponse.value
      }



      switch (conditionalAttribute.attributeName) {
        case "addressAttributes":
          try {
            field.addressAttributes = JSON.parse(foundValue)
          } catch(e) {
            // do nothing
          }
        case 'nullOptionLabel':
          field.nullOptionLabel = foundValue;
          break;
        case 'mode':
          field.mode = foundValue;
          break;
        case 'key':
          field.key = foundValue;
          break;
        case 'mask':
          field.mask = foundValue;
          break;
        case 'title':
        case 'label':
          field.title = foundValue;
          break;
        case 'triggerValidationAtURL':
          field.triggerValidationAtURL = foundValue;
          break;
        case 'requireTriggerConfirmation':
          field.requireTriggerConfirmation = foundValue;
          break;
        case 'helptext':
          field.helpText = foundValue;
          break;
        case 'regex':
          field.regex = foundValue;
          break;
        case 'minDate':
          field.minDate = foundValue;
          break;
        case 'maxDate':
          field.maxDate = foundValue;
          break;
        case 'options':
          // TODO: support options for conditional attributes
          break;
        case 'minLength':
          var iv = parseInt(foundValue);
          field.minLength = iv;
          break;
        case 'maxLength':
          var iv = parseInt(foundValue);
          field.maxLength = iv;
          break;
        case 'minValue':
          var f = parseFloat(foundValue);
          field.minValue = f;
          break;
        case 'maxValue':
          var f = parseFloat(foundValue);
          field.maxValue = f;
          break;
        case 'autoSuggestURL':
          var expr = new RegExp(/{{([^{}]*)}}/g)
          var replacementExpr = new RegExp(/{{(.*)}}/)
          var url = conditionalAttribute.attributeValue
          var parentParts = url.match(expr)
          if (parentParts && parentParts.length > 0) {
            parentParts.forEach(function(part){

              let foundPartValue = ""
              let findValResponse = findValueForTemplate(part)
              if (findValResponse && findValResponse.match == true) {
                foundPartValue = findValResponse.value
              }
              
              if (url && url.match && url.match(expr) != null && url.match(expr).length > 0) {
                url = url.replace(url.match(expr)[0], foundPartValue)
              }

            })
          } 

          field.autoSuggestURL = url;
      
          
          break;
        case 'probeAutoSuggestURL':
          var probeBool: boolean
          if  (conditionalAttribute.attributeValue == 'true') {
            probeBool = true
          } else if (conditionalAttribute.attributeValue == 'false') {
            probeBool = false
          } else {
            console.warn(
              "value '" +
                conditionalAttribute.attributeValue +
                "' is not supported for boolean attribute"
            );
          }
          field.probeAutoSuggestURL = probeBool;
          break;
          case 'freeSolo':
            var freeSoloBool: boolean
            if  (conditionalAttribute.attributeValue == 'true') {
              freeSoloBool = true
            } else if (conditionalAttribute.attributeValue == 'false') {
              freeSoloBool = false
            } else {
              console.warn(
                "value '" +
                  conditionalAttribute.attributeValue +
                  "' is not supported for boolean attribute"
              );
            }
            field.freeSolo = freeSoloBool;
            break;
        default:
          var attributeParts = conditionalAttribute.attributeName.toLowerCase().split("/")
          var supportedValue = false
          if (attributeParts.length > 1) {
            switch (attributeParts[0]) {
              case 'validationattributes':
                switch (attributeParts[1]) {
                  case 'maxattempts':
                    field.validationAttributes.maxAttempts = conditionalAttribute.attributeValue;
                    supportedValue = true
                    break;
                  case 'minattempts':
                    field.validationAttributes.minAttempts = conditionalAttribute.attributeValue;
                    supportedValue = true
                    break;
                  case 'mode':
                    field.validationAttributes.mode = conditionalAttribute.attributeValue;
                    supportedValue = true
                    break;
                  case 'allowresubmission':
                    if  (conditionalAttribute.attributeValue == 'true') {
                      field.validationAttributes.allowResubmission = true
                    } else if (conditionalAttribute.attributeValue == 'false') {
                      field.validationAttributes.allowResubmission = false
                    } else {
                      console.warn(
                        "value '" +
                          conditionalAttribute.attributeValue +
                          "' is not supported for boolean attribute"
                      );
                    }
                    supportedValue = true
                    break;
                  case 'requiresuccess':
                    if  (conditionalAttribute.attributeValue == 'true') {
                      field.validationAttributes.requireSuccess = true
                    } else if (conditionalAttribute.attributeValue == 'false') {
                      field.validationAttributes.requireSuccess = false
                    } else {
                      console.warn(
                        "value '" +
                          conditionalAttribute.attributeValue +
                          "' is not supported for boolean attribute"
                      );
                    }
                    supportedValue = true
                    break;
                  case 'forcesaveonrequest':
                    if  (field.validationAttributes.forceSaveOnRequest == 'true') {
                      field.validationAttributes.allowResubmission = true
                    } else if (field.validationAttributes.forceSaveOnRequest == 'false') {
                      field.validationAttributes.allowResubmission = false
                    } else {
                      console.warn(
                        "value '" +
                          conditionalAttribute.attributeValue +
                          "' is not supported for boolean attribute"
                      );
                    }
                    supportedValue = true
                    break;
                }
                case 'addressattributes':
                  switch (attributeParts[1]) {   
                    
                    case 'address1':
                      if (!field.addressAttributes.address1) {
                        field.addressAttributes.address1 = {}
                      }
                      if (attributeParts.length > 2) {
                        switch (attributeParts[2]) {   
                          case 'mode':
                            field.addressAttributes.address1.mode = conditionalAttribute.attributeValue;
                            break;
                          case 'minLength':
                            field.addressAttributes.address1.minLength = conditionalAttribute.attributeValue;
                            break;
                          case 'label':
                            field.addressAttributes.address1.label = conditionalAttribute.attributeValue;
                            break;
                        }
  
                      }
                      break;
                    case 'address2':
                      if (!field.addressAttributes.address2) {
                        field.addressAttributes.address2 = {}
                      }
                      if (attributeParts.length > 2) {
                        switch (attributeParts[2]) {   
                          case 'mode':
                            field.addressAttributes.address2.mode = conditionalAttribute.attributeValue;
                            break;
                          case 'minLength':
                            field.addressAttributes.address2.minLength = conditionalAttribute.attributeValue;
                            break;
                          case 'label':
                            field.addressAttributes.address2.label = conditionalAttribute.attributeValue;
                            break;
                        }
  
                      }
                      break;
                    case 'address3':
                      if (!field.addressAttributes.address3) {
                        field.addressAttributes.address3 = {}
                      }
                      if (attributeParts.length > 2) {
                        switch (attributeParts[2]) {   
                          case 'mode':
                            field.addressAttributes.address3.mode = conditionalAttribute.attributeValue;
                            break;
                          case 'minLength':
                            field.addressAttributes.address3.minLength = conditionalAttribute.attributeValue;
                            break;
                          case 'label':
                            field.addressAttributes.address3.label = conditionalAttribute.attributeValue;
                            break;
                        }
                      }
                      break;
                    case 'city':
                      if (!field.addressAttributes.city) {
                        field.addressAttributes.city = {}
                      }
                      if (attributeParts.length > 2) {
                        switch (attributeParts[2]) {   
                          case 'mode':
                            field.addressAttributes.city.mode = conditionalAttribute.attributeValue;
                            break;
                          case 'minLength':
                            field.addressAttributes.city.minLength = conditionalAttribute.attributeValue;
                            break;
                          case 'label':
                            field.addressAttributes.city.label = conditionalAttribute.attributeValue;
                            break;
                        }
                      }
                      break;
                    case 'county':
                      if (!field.addressAttributes.county) {
                        field.addressAttributes.county = {}
                      }
                      if (attributeParts.length > 2) {
                        switch (attributeParts[2]) {   
                          case 'mode':
                            field.addressAttributes.county.mode = conditionalAttribute.attributeValue;
                            break;
                          case 'minLength':
                            field.addressAttributes.county.minLength = conditionalAttribute.attributeValue;
                            break;
                          case 'label':
                            field.addressAttributes.county.label = conditionalAttribute.attributeValue;
                            break;
                        }
                      }
                      break;
                    case 'state':
                      if (!field.addressAttributes.state) {
                        field.addressAttributes.state = {}
                      }
                      if (attributeParts.length > 2) {
                        switch (attributeParts[2]) {   
                          case 'mode':
                            field.addressAttributes.state.mode = conditionalAttribute.attributeValue;
                            break;
                          case 'minLength':
                            field.addressAttributes.state.minLength = conditionalAttribute.attributeValue;
                            break;
                          case 'label':
                            field.addressAttributes.state.label = conditionalAttribute.attributeValue;
                            break;
                          case 'autosuggesturl':
                            field.addressAttributes.state.autoSuggestURL = conditionalAttribute.attributeValue;
                            break;
                          case 'probeautosuggesturl':
                            field.addressAttributes.state.probeAutoSuggestURL = conditionalAttribute.attributeValue;
                            break;
                        }
                      }
                      break;
                    case 'postalcode':
                      if (!field.addressAttributes.postalCode) {
                        field.addressAttributes.postalCode = {}
                      }
                      if (attributeParts.length > 2) {
                        switch (attributeParts[2]) {   
                          case 'mode':
                            field.addressAttributes.postalCode.mode = conditionalAttribute.attributeValue;
                            break;
                          case 'minLength':
                            field.addressAttributes.postalCode.minLength = conditionalAttribute.attributeValue;
                            break;
                          case 'label':
                            field.addressAttributes.postalCode.label = conditionalAttribute.attributeValue;
                            break;
                          case 'mask':
                            field.addressAttributes.postalCode.mask = conditionalAttribute.attributeValue;
                            break;
                          case 'regex':
                            field.addressAttributes.postalCode.regex = conditionalAttribute.attributeValue;
                            break;
                        }
                      }
                      break;
                    case 'country':
                      if (!field.addressAttributes.country) {
                        field.addressAttributes.country = {}
                      }
                      if (attributeParts.length > 2) {
                        switch (attributeParts[2]) {   
                          case 'mode':
                            field.addressAttributes.country.mode = conditionalAttribute.attributeValue;
                            break;
                          case 'minLength':
                            field.addressAttributes.country.minLength = conditionalAttribute.attributeValue;
                            break;
                          case 'label':
                            field.addressAttributes.country.label = conditionalAttribute.attributeValue;
                            break;
                        }
                      }
                      break;
                }
              }
          }
          if (!supportedValue){
            console.warn(
              "Attribute '" +
                conditionalAttribute.attributeName +
                "' is not supported for conditional"
            );
          }
          
      }
    }
  } else {
    console.warn('incomplete condition skipped', conditionalAttribute);
  }
}


// This is the Array.includes polyfill for IE 11
if (!Array.prototype.contains) {
  Object.defineProperty(Array.prototype, 'contains', {
    value: function(searchElement, fromIndex) {

      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        // NOTE: === provides the correct "SameValueZero" comparison needed here.
        if (o[k] === searchElement) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}
export function baseConditionalEval(pv: any, conditionalAttribute:any, sectionData:any){
  let exprResult:boolean = false
    // change here
    let condVal: any = conditionalAttribute.value;
      if (pv) {
        switch (typeof pv) {
          case 'number':
            try {
              condVal = parseFloat(conditionalAttribute.value);
            } catch (e) {}

          default:
            condVal = conditionalAttribute.value;
        }
      }

      switch (conditionalAttribute.operator) {
        case '==':
          if (condVal == '""' || condVal == "''" || !condVal) {
            exprResult = pv == '';
          } else if (condVal == 'true' || condVal == "'true'" || condVal == '"true"')  {
            exprResult = (pv === true || pv === 'true')
          } else if (condVal == 'false' || condVal == "'false'" || condVal == '"false"') {
            exprResult = (pv === false || pv === 'false')
          } else {
            exprResult = pv == condVal;
          }
          break;

        case '!=':
          exprResult = pv != condVal;
          break;

        case '<':
          exprResult = pv < condVal;
          break;

        case '<=':
          exprResult = pv <= condVal;
          break;

        case '>':
          exprResult = pv > condVal;
          break;

        case '>=':
          exprResult = pv >= condVal;
          break;

        case 'in':
          var parts = condVal.split("|")
            
            var valueParts: string[]
            exprResult =  parts.contains(pv)
            if (pv && !exprResult) {
              valueParts = pv.split("|")
              
              
              for (let vp of valueParts) {
                let found =  parts.contains(vp)
                if (found == true) {
                  exprResult = true
                }
              }
            }

           
          break;

        case 'not in', 'nin':
          var parts = condVal.split("|")
            
            var valueParts: string[]
            exprResult =  !parts.contains(pv)
            if (pv && !exprResult) {
              valueParts = pv.split("|")
              
              
              for (let vp of valueParts) {
                let notFound =  !parts.contains(vp)
                if (notFound == true) {
                  exprResult = true
                }
              }
            }
          break;
           

        case 'is':

          if (condVal == 'null' || condVal == "'null'" || condVal == '"null"') {
            exprResult = pv == null || pv == undefined;
          }

          if (condVal == 'falsy') {
            exprResult = pv == null || pv == undefined || pv == "" || (typeof(pv) === "object" && isEmpty(pv));
          }

          if (condVal == 'truthy') {
            exprResult = pv != null && pv != undefined && pv != "" && (typeof(pv) === "object" && !isEmpty(pv));
          }

          break;


        case 'is not':

          if (condVal == 'null' || condVal == "'null'" || condVal == '"null"') {
            exprResult = !(pv == null || pv == undefined);
          }

          if (condVal == 'falsy') {
            exprResult = !(pv == null || pv == undefined || pv == "" || (typeof(pv) === "object" && isEmpty(pv)));
          }

          if (condVal == 'truthy') {
            exprResult = !(pv != null && pv != undefined && pv != "" && (typeof(pv) === "object" && !isEmpty(pv)));
          }

          break;

        case 'has':

          if (condVal == 'storageKey') {
            if (pv && pv.active) {
              exprResult = pv.active.storageKey
            } 
          }

          if (condVal == 'uploadedBy') {
            if (pv && pv.active) {
              exprResult = pv.active.uploadedBy
            } 
          }

          if (condVal == 'docuSignEnvelopeInformation') {
            if (pv && pv.active) {
              exprResult = pv.active.docuSignEnvelopeInformation
            } 
          }
  
          break;

        case 'has no':
  
          if (condVal == 'storageKey') {
            if (pv && pv.active) {
              exprResult = !pv.active.storageKey
            } else {
              exprResult = !pv.active
            }
          }

          if (condVal == 'uploadedBy') {
            if (pv && pv.active) {
              exprResult = !pv.active.uploadedBy
            } else {
              exprResult = !pv.active
            }
          }

          if (condVal == 'docuSignEnvelopeInformation') {
            if (pv && pv.active) {
              exprResult = !pv.active.docuSignEnvelopeInformation
            } else {
              exprResult = !pv.active
            }
          }

          
  
          break;

        default:
          console.warn(
            "Unsupported conditional operator: '%s' for int at path '%s'",
            conditionalAttribute.Operator,
            conditionalAttribute.Path
          );
      }

      return exprResult
}

export function getValueForField(path: string, value: any): any {
  return value[path];
}

export function buildSectionTitle(
  classes: any,
  definition: Definition,
  path: string,
  policyMessages?: Array<any>,
  suppressTitle?: boolean,
  showSectionStatusIcon?: boolean,
  adminMode?: boolean,
  embedded?: boolean,
  titleOverride?: string
): any {
  if (definition && (definition.title || titleOverride) && !suppressTitle) {
    // If policy messages is null or undefined, we will not adjust the title at all
    let statusIcon: any = null;

    if (policyMessages !== null && policyMessages !== undefined) {
      // Check to see if we have any relevent errors and determine the state icon to display
      policyMessages.sort((a, b) => {
        return b.severity - a.severity;
      });
      const applicable = policyMessages.reduce((acc, m): Array<any> => {
        if (m.path.startsWith(path)) {
          acc.push(m);
        }
        return acc;
      }, []);

      // Since we sorted, the maximum severity will be first in the list
      if (applicable.length > 0) {
        switch (applicable[0].severity) {
          case 0:
            statusIcon = (
              <i className={classes.infoIcon + ' fa fas fa-info-circle'} />
            );
            break;

          case 1:
            statusIcon = (
              <i className={classes.warnIcon + ' fa fas fa-info-circle'} />
            );
            break;

          case 2:
            statusIcon = (
              <i
                className={classes.errorIcon + ' fa fas fa-exclamation-circle'}
              />
            );
            break;
        }
      } else {
        // this section has no errors but the policy has been run, so
        statusIcon = (
          <i className={classes.successIcon + ' fa fas fa-check-circle'} />
        );
      }
    }

    var className = classes.sectionTitle;
    if (embedded) {
      className = classes.embeddedSectionTitle;
    }

    var title = definition.title || titleOverride
    // if (titleOverride && titleOverride != "") {
    //   title = titleOverride
    // }
    return (
      <Typography className={className} variant="headline" gutterBottom>
        {showSectionStatusIcon && statusIcon} {title}
      </Typography>
    );
  }

  // return null;
  return (
    <Typography className={className} variant="headline" gutterBottom>
      {" "}
    </Typography>
  );
}

function isArray(obj: any): boolean {
  if (obj.isArray == undefined) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  } else {
    return obj.isArray(obj);
  }
}
